import type { Components } from "@mui/material/styles";

export const MuiStepper: Components["MuiStepper"] = {
  styleOverrides: {
    root: {
      padding: 0,
    },
  },
};

export const MuiStep: Components["MuiStep"] = {
  styleOverrides: {
    root: {
      padding: 0,
      "&.Mui-completed": {
        "& .MuiStepLabel-label": {
          color: "var(--color-black)",
        },
      },
    },
  },
};

export const MuiStepLabel: Components["MuiStepLabel"] = {
  styleOverrides: {
    root: {
      padding: "var(--rhythm) 0",
      paddingLeft: "var(--rhythm)",
      cursor: "pointer",
      borderLeft: "4px solid transparent",
      transition: "border-color 0.2s ease",
      "&:hover": {
        "& .MuiStepLabel-label": {
          color: "var(--color-primary)",
        },
      },
      "&.Mui-disabled": {
        cursor: "pointer",
        opacity: 0.5,
      },
    },
    label: {
      // fontSize: "var(--font-size-xs)",
      fontWeight: 400,
      color: "var(--color-black)",
      "&.Mui-active": {
        fontWeight: 800,
        color: "var(--color-primary)",
      },
      "&.Mui-completed": {
        fontWeight: 400,
        color: "var(--color-black)",
      },
    },
    iconContainer: {
      // display: "none", // Hide default icons, we show numbers in label
    },
  },
};

export const MuiStepConnector: Components["MuiStepConnector"] = {
  styleOverrides: {
    root: {
      display: "none", // Hide connectors for clean vertical list look
    },
  },
};

export const MuiStepIcon: Components["MuiStepIcon"] = {
  styleOverrides: {
    root: {
      color: "var(--color-grey-light)",
      "&.Mui-active": {
        color: "var(--color-primary)",
      },
      "&.Mui-completed": {
        color: "var(--color-primary)",
      },
    },
    text: {
      fontSize: "var(--font-size-xs)",
      fontWeight: 600,
    },
  },
};
